import Vue from 'vue'
import Router from 'vue-router'
import axios from "axios";
const _import = require('./_import');


Vue.use(Router)
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
export const constantRouterMap = [
  // 登录总页面
  {
    path: '/login',
    name: 'LoginIndex',
    component: _import('Login/index'),
    redirect: '/login/index',
    children: [
      // 登录
      {
        path: 'index',
        name: 'Login',
        component: _import('Login/login')
      },
      // 注册
      {
        path: 'register',
        name: 'Register',
        component: _import('Login/register')
      },
      // 忘记密码
      {
        path: 'forgetPass',
        name: 'ForgetPass',
        component: _import('Login/forgetPass')
      },
      //修改密码
      {
        path: 'changePass',
        name: 'ChangePass',
        component: _import('Login/changePass')
      },
      //重置密码
      {
        path: 'resetPass',
        name: 'ResetPass',
        component: _import('Login/resetPass')
      }
    ]
  },
  // 总首页
  {
    path: '/education',
    name: 'Education',
    meta: {title: '首页'},
    component: _import('Education/education'),
    redirect: '/education/index',
    children: [
      // 首页
      {
        path: 'index',
        name: 'EducationIndex',
        meta: {title: '首页'},
        component: _import('Education/index')
      },
      {
        // 文档分享首页
        path: 'pictureShare',
        name: 'pictureShare',
        meta: {title: '图片'},
        component: _import('Education/pictureShare')
      },
      {
        // 首页介绍图
        path: 'indexIntro',
        name: 'indexIntro',
        meta: {title: '图片'},
        component: _import('Education/indexIntro')
      },
      {
        // 文档分享首页
        path: 'pictureList',
        name: 'pictureList',
        meta: {title: '图片'},
        component: _import('Education/components/index/pictureList')
      },
      {
        // 专题图片
        path: 'zhuantipictureList',
        name: 'ZhuantipictureList',
        meta: {title: '专题图片'},
        component: _import('Education/components/index/zhuantipictureList')
      },
      {
        // 专题图片
        path: 'zhuantiFenList',
        name: 'ZhuantiFenList',
        meta: {title: '分专题图片'},
        component: _import('Education/components/index/zhuantiFenList')
      },
      {
        // 图片详情页
        path:'imageDetails',
        name:'imageDetails',
        meta:{title: '图片详情'},
        component: _import('Education/components/imageList/imageDetails')
      },
      // 用户中心
      {
        path:'personalcenter',
        name: 'personalcenter',
        meta: {title: '用户中心'},
        component: _import('Personalcenter/personalcenter'),
        redirect: 'personalcenter/userinfo',
        children:[
          {
            // 我上传的图片
            path:'mypicfile',
            name:"mypicfile",
            meta:{title:'我上传的图片'},
            component: _import('Personalcenter/components/my/mypicfile')
          },
          {
            // 我上传的图片
            path:'mypicbuy',
            name:"mypicbuy",
            meta:{title:'我的购买记录'},
            component: _import('Personalcenter/components/my/mypicbuy')
          },
          {
            // 课件上传
            path:'picUpload',
            name:"picUpload",
            meta:{title:'图片上传'},
            component: _import('Personalcenter/components/my/picUpload')
          },
          {
            // 本地资料
            path:'purchasedresource',
            name:"purchasedresource",
            meta:{title:'已购买资源'},
            component: _import('Personalcenter/components/my/purchasedResource')
          },
          {
            // 图片上传
            path:'picUpload',
            name:"picUpload",
            meta:{title:'图片上传'},
            component: _import('Personalcenter/components/my/picUpload')
          },

          {
            // 编辑图片
            path:'updatePic',
            name:"updatePic",
            meta:{title:'编辑图片'},
            component: _import('Personalcenter/components/my/updatePic')
          },
          {
            // 安全设置
            path:'securityset',
            name:"securityset",
            meta:{title:'安全设置'},
            component: _import('Personalcenter/components/my/setting/index')
          },
          {
            // 密码修改
            path:'setpwd',
            name:"setpwd",
            meta:{title:'修改密码'},
            component: _import('Personalcenter/components/my/setting/setPwd')
          },
          {
            // 更换手机号
            path:'setphone',
            name:"setphone",
            meta:{title:'更换手机号'},
            component: _import('Personalcenter/components/my/setting/setPhone')
          },
          {
            // 身份认证
            path:'authentication',
            name:"authentication",
            meta:{title:'身份证认证'},
            component: _import('Personalcenter/components/my/setting/authentication')
          },
          {
            //账户绑定
            path:'accountbind',
            name:"accountbind",
            meta:{title:'账户绑定'},
            component: _import('Personalcenter/components/my/setting/accountbind')
          },
          {
            // 个人信息
            path:'userinfo',
            name:"userinfo",
            meta:{title:'个人信息'},
            component: _import('Personalcenter/components/my/userinfo')
          },
          {
            // 我的关注
            path:'attention',
            name:"attention",
            meta:{title:'我的关注'},
            component: _import('Personalcenter/components/my/myattention')
          },
          {
            // 我收藏的课件
            path:'collect',
            name:"collect",
            meta:{title:'我的收藏'},
            component: _import('Personalcenter/components/my/mycollect')
          },
          {
            // 我的下载
            path:'download',
            name:"download",
            meta:{title:'我的下载'},
            component: _import('Personalcenter/components/my/mydownload')
          },
          {
            // 申请成为教师
            path:'apply',
            name:"apply",
            meta:{title:'申请成为教师'},
            component: _import('Personalcenter/components/my/apply')
          },
          {
            path: 'datails',
            name: 'Datails',
            meta: {title: '详情展示'},
            component: _import('Personalcenter/components/my/datails')
          },
        ]
      },

    ]
  },
  // 404
  {
    path: '/404',
    name: '404',
    component: _import('404/404')
  },
  // 默认路径
  {
    path: '/',
    redirect: '/education'
  }
]



export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '*',
    redirect: '/education',
    hidden: true
  }
]

//------------------请求拦截-------------------//
//------------在发送请求之前做些什么------------//
/*
axios.interceptors.request.use(config => {
  //例：若存在token则带token
    config.headers.requestTypeEss = "essvue"
  return config;
}, err => {
  console.log("请求拦截=>", err);
  return err;
})
*/

//------------------响应拦截-------------------//
//-------------对响应数据做点什么-------------//
axios.interceptors.response.use(res => {
  // console.log("响应拦截=>", res.data);
  //例：后端数据处理错误，并返回错误原因；前端获取错误原因并展示
  if (res.data.success == false) {
    Message({
      message: res.data.data.message + '，请重试！',
      type: 'warning'
    });
  }
  return res;
}, err => {
  // console.log(err);
  //打印完整的错误信息
  // console.log("响应拦截错误完整信息=>",err.response)
  //也可以在这里对不同的错误码做不同的展示处理
  if (err.response !=undefined && err.response.status == 401){
    sessionStorage.removeItem("user")
    // parent.window.location.href = "./#/login/index";
    window.localStorage.removeItem("AITerminal_token");
    window.localStorage.removeItem("password");
    window.localStorage.removeItem("user");


  }
  throw err;
})





// WEBPACK FOOTER //
// ./src/router/index.js